import { render, staticRenderFns } from "./customerName.vue?vue&type=template&id=9fc1bd6a&scoped=true"
import script from "./customerName.vue?vue&type=script&lang=js"
export * from "./customerName.vue?vue&type=script&lang=js"
import style0 from "./customerName.vue?vue&type=style&index=0&id=9fc1bd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc1bd6a",
  null
  
)

export default component.exports